/* eslint-disable jsx-a11y/heading-has-content */
import React from "react";

const PrivacyPolicy = () => {
  return (
    <>
      <article
        className="page"
        style={{
          backgroundColor: "#e0e0e0",
        }}
      >
        <section className="page-content pt-5">
          <div className="container">
            <div className="row">
              <div className="wysiwyg col-md-8 mx-auto">
                <h2 className="text_48_privacy">Privacy Policy</h2>
                <p className="text_18_privacy">Last updated: Aug 14, 2024</p>
                <p className="text_18_privacy">
                  Lorem ipsum, dolor sit amet consectetur adipisicing elit. Esse
                  natus ea modi similique consequatur cumque est blanditiis
                  perferendis voluptatem labore deserunt ipsa consequuntur
                  itaque recusandae dolore, rem quasi autem voluptate!
                </p>
                <p className="text_18_privacy">
                  Lorem ipsum, dolor sit amet consectetur adipisicing elit. Esse
                  natus ea modi similique consequatur cumque est blanditiis
                  perferendis voluptatem labore deserunt ipsa consequuntur
                  itaque recusandae dolore, rem quasi autem voluptate!
                </p>
                <p />
                <h3>Interpretation and Definitions</h3>
                <h4 />
                <h4>Interpretation</h4>
                <p className="text_18_privacy">
                  Lorem ipsum, dolor sit amet consectetur adipisicing elit. Esse
                  natus ea modi similique consequatur cumque est blanditiis
                  perferendis voluptatem labore deserunt ipsa consequuntur
                  itaque recusandae dolore, rem quasi autem voluptate!
                </p>
                <h4 />
                <h4>Definitions</h4>
                <p className="text_18_privacy">For the purposes of this Privacy Policy:</p>
                <ul>
                  <li className="text_18_privacy">
                    <strong>Account</strong> means a unique account created for
                    You to access our Service or parts of our Service.
                  </li>
                  <li className="text_18_privacy">
                    <strong>Affiliate</strong> Lorem ipsum, dolor sit amet
                    consectetur adipisicing elit. Esse natus ea modi similique
                    consequatur cumque est blanditiis perferendis voluptatem
                    labore deserunt ipsa consequuntur itaque recusandae dolore,
                    rem quasi autem voluptate!
                  </li>
                  <li className="text_18_privacy">
                    <strong>Business</strong>, Lorem ipsum, dolor sit amet
                    consectetur adipisicing elit. Esse natus ea modi similique
                    consequatur cumque est blanditiis perferendis voluptatem
                    labore deserunt ipsa consequuntur itaque recusandae dolore,
                    rem quasi autem voluptate!
                  </li>
                  <li className="text_18_privacy">
                    <strong>CCPA</strong> and/or <strong>CPRA</strong> refers to
                    California Consumer Privacy Act (the "CCPA") as amended by
                    the California Privacy Rights Act of 2020 (the "CPRA").
                  </li>
                  <li className="text_18_privacy">
                    <strong>Company</strong> Lorem ipsum, dolor sit amet
                    consectetur adipisicing elit. Esse natus ea modi similique
                    consequatur cumque est blanditiis perferendis voluptatem
                    labore deserunt ipsa consequuntur itaque recusandae dolore,
                    rem quasi autem voluptate!
                    <ul>
                      <li className="text_18_privacy">
                        Lorem ipsum, dolor sit amet consectetur adipisicing
                        elit.
                      </li>
                    </ul>
                  </li>
                  <li className="text_18_privacy">
                    <strong>Consumer</strong>, Lorem ipsum, dolor sit amet
                    consectetur adipisicing elit. Esse natus ea modi similique
                    consequatur cumque est blanditiis perferendis voluptatem
                    labore deserunt ipsa consequuntur itaque recusandae dolore,
                    rem quasi autem voluptate!
                  </li>
                  <li className="text_18_privacy">
                    <strong>Cookies</strong> Lorem ipsum, dolor sit amet
                    consectetur adipisicing elit. Esse natus ea modi similique
                    consequatur cumque est blanditiis perferendis voluptatem
                    labore deserunt ipsa consequuntur itaque recusandae dolore,
                    rem quasi autem voluptate!
                  </li>
                  <li className="text_18_privacy">
                    <strong>Country</strong> refers to: Delaware, United States
                  </li>
                  <li className="text_18_privacy">
                    <strong>Data Controller</strong>, Lorem ipsum, dolor sit
                    amet consectetur adipisicing elit. Esse natus ea modi
                    similique consequatur cumque est blanditiis perferendis
                    voluptatem labore deserunt ipsa consequuntur itaque
                    recusandae dolore, rem quasi autem voluptate!
                  </li>
                  <li className="text_18_privacy">
                    <strong>Device</strong> means any device that can access the
                    Service such as a computer, a cellphone or a digital tablet.
                  </li>
                  <li className="text_18_privacy">
                    <strong>Do Not Track</strong> Lorem ipsum, dolor sit amet
                    consectetur adipisicing elit. Esse natus ea modi similique
                    consequatur cumque est blanditiis perferendis voluptatem
                    labore deserunt ipsa consequuntur itaque recusandae dolore,
                    rem quasi autem voluptate!
                  </li>
                  <li className="text_18_privacy">
                    <strong>GDPR</strong> Lorem ipsum, dolor sit amet
                    consectetur adipisicing elit.
                  </li>
                  <li className="text_18_privacy">
                    <strong>Personal Data</strong> Lorem ipsum, dolor sit amet
                    consectetur adipisicing elit.
                    <ul>
                      <li className="text_18_privacy">
                        Lorem ipsum, dolor sit amet consectetur adipisicing
                        elit. Esse natus ea modi similique consequatur cumque
                        est blanditiis perferendis voluptatem labore deserunt
                        ipsa consequuntur itaque recusandae dolore, rem quasi
                        autem voluptate!
                      </li>
                      <li className="text_18_privacy">
                        Lorem ipsum, dolor sit amet consectetur adipisicing
                        elit. Esse natus ea modi similique consequatur cumque
                        est blanditiis perferendis voluptatem labore deserunt
                        ipsa consequuntur itaque recusandae dolore, rem quasi
                        autem voluptate!
                      </li>
                    </ul>
                  </li>
                  <li className="text_18_privacy">
                    <strong>Service</strong> refers to the Website.
                  </li>
                  <li className="text_18_privacy">
                    <strong>Service Provider</strong> Lorem ipsum, dolor sit
                    amet consectetur adipisicing elit. Esse natus ea modi
                    similique consequatur cumque est blanditiis perferendis
                    voluptatem labore deserunt ipsa consequuntur itaque
                    recusandae dolore, rem quasi autem voluptate!
                  </li>
                  <li className="text_18_privacy">
                    <strong>Usage Data</strong> Lorem ipsum, dolor sit amet
                    consectetur adipisicing elit. Esse natus ea modi similique
                    consequatur cumque est blanditiis perferendis voluptatem
                    labore deserunt ipsa consequuntur itaque recusandae dolore,
                    rem quasi autem voluptate!
                  </li>
                  <li className="text_18_privacy">
                    <strong>Website</strong> Lorem ipsum, dolor sit amet
                    consectetur adipisicing elit. Esse natus ea modi similique
                    consequatur cumque est blanditiis perferendis voluptatem
                    labore deserunt ipsa consequuntur itaque recusandae dolore,
                    rem quasi autem voluptate!
                  </li>
                  <li className="text_18_privacy">
                    <strong>You</strong> Lorem ipsum, dolor sit amet consectetur
                    adipisicing elit. Esse natus ea modi similique consequatur
                    cumque est blanditiis perferendis voluptatem labore deserunt
                    ipsa consequuntur itaque recusandae dolore, rem quasi autem
                    voluptate!
                    <ul>
                      <li className="text_18_privacy">
                        Lorem ipsum, dolor sit amet consectetur adipisicing
                        elit. Esse natus ea modi similique consequatur cumque
                        est blanditiis perferendis voluptatem.
                      </li>
                    </ul>
                  </li>
                </ul>
                <h3 />
                <h3>Collecting and Using Your Personal Data</h3>
                <h4 />
                <h4>Types of Data Collected</h4>
                <p className="text_18_privacy">
                  <strong>Personal Data</strong>
                </p>
                <p className="text_18_privacy">
                  Lorem ipsum, dolor sit amet consectetur adipisicing elit. Esse
                  natus ea modi similique consequatur cumque est blanditiis
                  perferendis voluptatem labore deserunt ipsa consequuntur
                  itaque recusandae dolore, rem quasi autem voluptate!
                </p>
                <ul>
                  <li className="text_18_privacy">Email address</li>
                  <li className="text_18_privacy">Usage Data</li>
                </ul>
                <p />
                <p className="text_18_privacy">
                  <strong>Usage Data</strong>
                </p>
                <p className="text_18_privacy">
                  {" "}
                  Lorem ipsum, dolor sit amet consectetur adipisicing elit.
                </p>
                <p className="text_18_privacy">
                  Lorem ipsum, dolor sit amet consectetur adipisicing elit. Esse
                  natus ea modi similique consequatur cumque est blanditiis
                  perferendis voluptatem labore deserunt ipsa consequuntur
                  itaque recusandae dolore, rem quasi autem voluptate!
                </p>
                <p className="text_18_privacy">
                  Lorem ipsum, dolor sit amet consectetur adipisicing elit. Esse
                  natus ea modi similique consequatur cumque est blanditiis
                  perferendis voluptatem labore deserunt ipsa consequuntur
                  itaque recusandae dolore, rem quasi autem voluptate!
                </p>
                <p className="text_18_privacy">
                  Lorem ipsum, dolor sit amet consectetur adipisicing elit. Esse
                  natus ea modi similique consequatur cumque est blanditiis
                  perferendis voluptatem labore deserunt ipsa consequuntur
                  itaque recusandae dolore, rem quasi autem voluptate!
                </p>
                <h3 />
                <h3>Tracking Technologies and Cookies</h3>
                <p className="text_18_privacy">
                  Lorem ipsum, dolor sit amet consectetur adipisicing elit. Esse
                  natus ea modi similique consequatur cumque est blanditiis
                  perferendis voluptatem labore deserunt ipsa consequuntur
                  itaque recusandae dolore, rem quasi autem voluptate!
                </p>
                <ul>
                  <li className="text_18_privacy">
                    <strong>Cookies or Browser Cookies.</strong> Lorem ipsum,
                    dolor sit amet consectetur adipisicing elit. Esse natus ea
                    modi similique consequatur cumque est blanditiis perferendis
                    voluptatem labore deserunt ipsa consequuntur itaque
                    recusandae dolore, rem quasi autem voluptate!
                  </li>
                  <li className="text_18_privacy">
                    <strong>Web Beacons.</strong> Lorem ipsum, dolor sit amet
                    consectetur adipisicing elit. Esse natus ea modi similique
                    consequatur cumque est blanditiis perferendis voluptatem
                    labore deserunt ipsa consequuntur itaque recusandae dolore,
                    rem quasi autem voluptate!
                  </li>
                </ul>
                <p className="text_18_privacy">
                  Lorem ipsum, dolor sit amet consectetur adipisicing elit. Esse
                  natus ea modi similique consequatur cumque est blanditiis
                  perferendis voluptatem labore deserunt ipsa consequuntur
                  itaque recusandae dolore, rem quasi autem voluptate!
                </p>
                <p className="text_18_privacy">
                  Lorem ipsum, dolor sit amet consectetur adipisicing elit.
                </p>
                <p />
                <p className="text_18_privacy">
                  <strong>Necessary / Essential Cookies</strong>
                </p>
                <ul>
                  <li className="text_18_privacy">Type: Session Cookies</li>
                  <li className="text_18_privacy">Administered by: Us</li>
                  <li className="text_18_privacy">
                    Lorem ipsum, dolor sit amet consectetur adipisicing elit.
                    Esse natus ea modi similique consequatur cumque est
                    blanditiis perferendis voluptatem labore deserunt ipsa
                    consequuntur itaque recusandae dolore, rem quasi autem
                    voluptate!
                  </li>
                </ul>
                <h5 />
                <p className="text_18_privacy">
                  <strong>Cookies Policy / Notice Acceptance Cookies</strong>
                </p>
                <ul>
                  <li className="text_18_privacy">Type: Persistent Cookies</li>
                  <li className="text_18_privacy">Administered by: Us</li>
                  <li className="text_18_privacy">
                    Lorem ipsum, dolor sit amet consectetur adipisicing elit.
                    Esse natus ea modi similique consequatur cumque est
                    blanditiis perferendis .
                  </li>
                </ul>
                <h5 />
                <p className="text_18_privacy">
                  <strong>Functionality Cookies</strong>
                </p>
                <ul>
                  <li className="text_18_privacy">Type: Persistent Cookies</li>
                  <li className="text_18_privacy">Administered by: Us</li>
                  <li className="text_18_privacy">
                    Lorem ipsum, dolor sit amet consectetur adipisicing elit.
                    Esse natus ea modi similique consequatur cumque est
                    blanditiis perferendis voluptatem labore deserunt ipsa
                    consequuntur itaque recusandae dolore, rem quasi autem
                    voluptate!
                  </li>
                </ul>
                <h5 />
                <p className="text_18_privacy">
                  <strong>Tracking and Performance Cookies</strong>
                </p>
                <ul>
                  <li className="text_18_privacy">Type: Persistent Cookies</li>
                  <li className="text_18_privacy">Administered by: Third-Parties</li>
                  <li className="text_18_privacy">
                    Lorem ipsum, dolor sit amet consectetur adipisicing elit.
                    Esse natus ea modi similique consequatur cumque est
                    blanditiis perferendis voluptatem labore deserunt ipsa
                    consequuntur itaque recusandae dolore, rem quasi autem
                    voluptate!
                  </li>
                </ul>
                <p className="text_18_privacy">
                  Lorem ipsum, dolor sit amet consectetur adipisicing elit. Esse
                  natus ea modi similique consequatur cumque est blanditiis
                  perferendis voluptatem labore deserunt ipsa consequuntur
                  itaque recusandae dolore, rem quasi autem voluptate!
                </p>
                <h3 />
                <h3>Use of Your Personal Data</h3>
                <p className="text_18_privacy">
                  {" "}
                  Lorem ipsum, dolor sit amet consectetur adipisicing elit.
                </p>
                <ul>
                  <li className="text_18_privacy">
                    <strong>To provide and maintain our Service</strong>,
                    including to monitor the usage of our Service.
                  </li>
                  <li className="text_18_privacy">
                    <strong>To manage Your Account:</strong> Lorem ipsum, dolor
                    sit amet consectetur adipisicing elit. Esse natus ea modi
                    similique consequatur cumque est blanditiis perferendis
                    voluptatem labore deserunt ipsa consequuntur itaque
                    recusandae dolore, rem quasi autem voluptate!
                  </li>
                  <li className="text_18_privacy">
                    <strong>For the performance of a contract:</strong> Lorem
                    ipsum, dolor sit amet consectetur adipisicing elit. Esse
                    natus ea modi similique consequatur cumque est blanditiis
                    perferendis voluptatem labore deserunt ipsa consequuntur
                    itaque recusandae dolore, rem quasi autem voluptate!
                  </li>
                  <li className="text_18_privacy">
                    <strong>To contact You:</strong> Lorem ipsum, dolor sit amet
                    consectetur adipisicing elit. Esse natus ea modi similique
                    consequatur cumque est blanditiis perferendis voluptatem
                    labore deserunt ipsa consequuntur itaque recusandae dolore,
                    rem quasi autem voluptate!
                  </li>
                  <li className="text_18_privacy">
                    <strong>To provide You</strong> Lorem ipsum, dolor sit amet
                    consectetur adipisicing elit. Esse natus ea modi similique
                    consequatur cumque est blanditiis perferendis voluptatem
                    labore deserunt ipsa consequuntur itaque recusandae dolore,
                    rem quasi autem voluptate!
                  </li>
                  <li className="text_18_privacy">
                    <strong>To manage Your requests:</strong> Lorem ipsum, dolor
                    sit amet consectetur adipisicing elit.
                  </li>
                  <li className="text_18_privacy">
                    <strong>For business transfers:</strong> Lorem ipsum, dolor
                    sit amet consectetur adipisicing elit. Esse natus ea modi
                    similique consequatur cumque est blanditiis perferendis
                    voluptatem labore deserunt ipsa consequuntur itaque
                    recusandae dolore, rem quasi autem voluptate!
                  </li>
                  <li className="text_18_privacy">
                    <strong>For other purposes</strong>: Lorem ipsum, dolor sit
                    amet consectetur adipisicing elit. Esse natus ea modi
                    similique consequatur cumque est blanditiis perferendis
                    voluptatem labore deserunt ipsa consequuntur itaque
                    recusandae dolore, rem quasi autem voluptate!
                  </li>
                </ul>
                <p className="text_18_privacy">
                  We may share Your personal information in the following
                  situations:
                </p>
                <ul>
                  <li className="text_18_privacy">
                    <strong>With Service Providers:</strong> Lorem ipsum, dolor
                    sit amet consectetur adipisicing elit. Esse natus ea modi
                    similique consequatur cumque est blanditiis perferendis
                    voluptatem labore deserunt ipsa consequuntur itaque
                    recusandae dolore, rem quasi autem voluptate!
                  </li>
                  <li className="text_18_privacy">
                    <strong>For business transfers:</strong> Lorem ipsum, dolor
                    sit amet consectetur adipisicing elit. Esse natus ea modi
                    similique consequatur cumque est blanditiis perferendis
                    voluptatem labore deserunt ipsa consequuntur itaque
                    recusandae dolore, rem quasi autem voluptate!
                  </li>
                  <li className="text_18_privacy">
                    <strong>With Affiliates:</strong> Lorem ipsum, dolor sit
                    amet consectetur adipisicing elit. Esse natus ea modi
                    similique consequatur cumque est blanditiis perferendis
                    voluptatem labore deserunt ipsa consequuntur itaque
                    recusandae dolore, rem quasi autem voluptate!
                  </li>
                  <li className="text_18_privacy">
                    <strong>With business partners:</strong> Lorem ipsum, dolor
                    sit amet consectetur adipisicing elit. Esse natus ea modi
                    similique consequatur cumque est blanditiis perferendis
                    voluptatem labore deserunt ipsa consequuntur itaque
                    recusandae dolore, rem quasi autem voluptate!
                  </li>
                  <li className="text_18_privacy">
                    <strong>With other users:</strong> Lorem ipsum, dolor sit
                    amet consectetur adipisicing elit. Esse natus ea modi
                    similique consequatur cumque est blanditiis perferendis
                    voluptatem labore deserunt ipsa consequuntur itaque
                    recusandae dolore, rem quasi autem voluptate!
                  </li>
                  <li className="text_18_privacy">
                    <strong>With Your consent</strong>: Lorem ipsum, dolor sit
                    amet consectetur adipisicing elit.
                  </li>
                </ul>
                <h3 />
                <h3>Retention of Your Personal Data</h3>
                <p className="text_18_privacy">
                  Lorem ipsum, dolor sit amet consectetur adipisicing elit. Esse
                  natus ea modi similique consequatur cumque est blanditiis
                  perferendis voluptatem labore deserunt ipsa consequuntur
                  itaque recusandae dolore, rem quasi autem voluptate!
                </p>
                <p className="text_18_privacy">
                  Lorem ipsum, dolor sit amet consectetur adipisicing elit. Esse
                  natus ea modi similique consequatur cumque est blanditiis
                  perferendis voluptatem labore deserunt ipsa consequuntur
                  itaque recusandae dolore, rem quasi autem voluptate!
                </p>
                <h3 />
                <h3>Transfer of Your Personal Data</h3>
                <p className="text_18_privacy">
                  Lorem ipsum, dolor sit amet consectetur adipisicing elit. Esse
                  natus ea modi similique consequatur cumque est blanditiis
                  perferendis voluptatem labore deserunt ipsa consequuntur
                  itaque recusandae dolore, rem quasi autem voluptate!
                </p>
                <p className="text_18_privacy">
                  Lorem ipsum, dolor sit amet consectetur adipisicing elit. Esse
                  natus ea modi similique consequatur cumque est blanditiis
                  perferendis .
                </p>
                <p className="text_18_privacy">
                  Lorem ipsum, dolor sit amet consectetur adipisicing elit. Esse
                  natus ea modi similique consequatur cumque est blanditiis
                  perferendis voluptatem labore deserunt ipsa consequuntur
                  itaque recusandae dolore, rem quasi autem voluptate!
                </p>
                <h3 />
                <h3>Delete Your Personal Data</h3>
                <p className="text_18_privacy">
                  Lorem ipsum, dolor sit amet consectetur adipisicing elit. Esse
                  natus ea modi similique consequatur cumque est blanditiis
                  perferendis.
                </p>
                <p className="text_18_privacy">
                  Our Service may give You the ability to delete certain
                  information about You from within the Service.
                </p>
                <p className="text_18_privacy">
                  Lorem ipsum, dolor sit amet consectetur adipisicing elit. Esse
                  natus ea modi similique consequatur cumque est blanditiis
                  perferendis voluptatem labore deserunt ipsa consequuntur
                  itaque recusandae dolore, rem quasi autem voluptate!
                </p>
                <p className="text_18_privacy">
                  Lorem ipsum, dolor sit amet consectetur adipisicing elit. Esse
                  natus ea modi similique consequatur cumque est blanditiis
                  perferendis.
                </p>
                <h3 />
                <h3>Disclosure of Your Personal Data</h3>
                <h5 />
                <h5>Business Transactions</h5>
                <p className="text_18_privacy">
                  Lorem ipsum, dolor sit amet consectetur adipisicing elit. Esse
                  natus ea modi similique consequatur cumque est blanditiis
                  perferendis voluptatem labore deserunt ipsa consequuntur
                  itaque recusandae dolore, rem quasi autem voluptate!
                </p>
                <h4 />
                <h5>Law enforcement</h5>
                <p className="text_18_privacy">
                  Lorem ipsum, dolor sit amet consectetur adipisicing elit. Esse
                  natus ea modi similique consequatur cumque est blanditiis
                  perferendis voluptatem labore deserunt ipsa consequuntur
                  itaque recusandae dolore, rem quasi autem voluptate!
                </p>
                <h4 />
                <h5>Other legal requirements</h5>
                <p className="text_18_privacy">
                  Lorem ipsum, dolor sit amet consectetur adipisicing elit. Esse
                  natus ea modi similique consequatur cumque est .
                </p>
                <ul>
                  <li className="text_18_privacy">Comply with a legal obligation</li>
                  <li className="text_18_privacy">
                    Protect and defend the rights or property of the Company
                  </li>
                  <li className="text_18_privacy">
                    Prevent or investigate possible wrongdoing in connection
                    with the Service
                  </li>
                  <li className="text_18_privacy">
                    Protect the personal safety of Users of the Service or the
                    public
                  </li>
                  <li className="text_18_privacy">Protect against legal liability</li>
                </ul>
                <h3 />
                <h3>Security of Your Personal Data</h3>
                <p className="text_18_privacy">
                  Lorem ipsum, dolor sit amet consectetur adipisicing elit. Esse
                  natus ea modi similique consequatur cumque est blanditiis
                  perferendis voluptatem labore deserunt ipsa consequuntur
                  itaque recusandae dolore, rem quasi autem voluptate!
                </p>
                <h3 />
                <h3>
                  Detailed Information on the Processing of Your Personal Data
                </h3>
                <p className="text_18_privacy">
                  Lorem ipsum, dolor sit amet consectetur adipisicing elit. Esse
                  natus ea modi similique consequatur cumque est blanditiis
                  perferendis voluptatem labore deserunt ipsa consequuntur
                  itaque recusandae dolore, rem quasi autem voluptate!
                </p>
                <h4 />
                <h4>Analytics</h4>
                <p className="text_18_privacy">
                  We may use third-party Service providers to monitor and
                  analyze the use of our Service.
                </p>
                <p />
                <p className="text_18_privacy">
                  <strong>Google Analytics</strong>
                </p>
                <p className="text_18_privacy">
                  Lorem ipsum, dolor sit amet consectetur adipisicing elit. Esse
                  natus ea modi similique consequatur cumque est blanditiis
                  perferendis voluptatem labore deserunt ipsa consequuntur
                  itaque recusandae dolore, rem quasi autem voluptate!
                </p>
                <p className="text_18_privacy">
                  Lorem ipsum, dolor sit amet consectetur adipisicing elit. Esse
                  natus ea modi similique consequatur cumque est blanditiis
                  perferendis voluptatem labore deserunt ipsa consequuntur
                  itaque recusandae dolore, rem quasi autem voluptate!
                </p>
                <p className="text_18_privacy">
                  Lorem ipsum, dolor sit amet consectetur adipisicing elit. Esse
                  natus ea modi similique consequatur cumque est blanditiis
                  perferendis voluptatem labore deserunt ipsa consequuntur
                  itaque recusandae dolore, rem quasi autem voluptate!
                </p>
                <p />
                <p className="text_18_privacy">
                  <strong>Email Marketing</strong>
                </p>
                <p className="text_18_privacy">
                  Lorem ipsum, dolor sit amet consectetur adipisicing elit. Esse
                  natus ea modi similique consequatur cumque est blanditiis
                  perferendis voluptatem labore deserunt ipsa consequuntur
                  itaque recusandae dolore, rem quasi autem voluptate!
                </p>
                <p className="text_18_privacy">
                  Lorem ipsum, dolor sit amet consectetur adipisicing elit. Esse
                  natus ea modi similique consequatur cumque est blanditiis
                  perferendis voluptatem labore deserunt ipsa consequuntur
                  itaque recusandae dolore, rem quasi autem voluptate!
                </p>
                <p />
                <p className="text_18_privacy">
                  <strong>Mailchimp</strong>
                </p>
                <p className="text_18_privacy">
                  Lorem ipsum, dolor sit amet consectetur adipisicing elit. Esse
                  natus ea modi similique consequatur cumque est blanditiis
                  perferendis voluptatem labore deserunt ipsa consequuntur
                  itaque recusandae dolore, rem quasi autem voluptate!
                </p>
                <p className="text_18_privacy">
                  For more information on the privacy practices of Mailchimp,
                  please visit their Privacy policy:{" "}
                  <a href="https://mailchimp.com/legal/privacy/">
                    https://mailchimp.com/legal/privacy/
                  </a>
                </p>
                <h3 />
                <h3>GDPR Privacy</h3>
                <h4 />
                <h4>Legal Basis for Processing Personal Data under GDPR</h4>
                <p className="text_18_privacy">
                  We may process Personal Data under the following conditions:
                </p>
                <ul>
                  <li className="text_18_privacy">
                    <strong>Consent:</strong> Lorem ipsum, dolor sit amet
                    consectetur adipisicing elit. Esse natus ea modi similique
                    consequatur cumque est blanditiis perferendis voluptatem
                    labore deserunt ipsa consequuntur itaque recusandae dolore,
                    rem quasi autem voluptate!
                  </li>
                  <li className="text_18_privacy">
                    <strong>Performance of a contract:</strong> Lorem ipsum,
                    dolor sit amet consectetur adipisicing elit. Esse natus ea
                    modi similique consequatur cumque est blanditiis perferendis
                    voluptatem labore deserunt ipsa consequuntur itaque
                    recusandae dolore, rem quasi autem voluptate!
                  </li>
                  <li className="text_18_privacy">
                    <strong>Legal obligations:</strong> Lorem ipsum, dolor sit
                    amet consectetur adipisicing elit. Esse natus ea modi
                    similique consequatur cumque est blanditiis perferendis
                    voluptatem labore deserunt ipsa consequuntur itaque
                    recusandae dolore, rem quasi autem voluptate!
                  </li>
                  <li className="text_18_privacy">
                    <strong>Vital interests:</strong> Lorem ipsum, dolor sit
                    amet consectetur adipisicing elit. Esse natus ea modi
                    similique consequatur cumque est blanditiis perferendis
                    voluptatem labore deserunt ipsa consequuntur itaque
                    recusandae dolore, rem quasi autem voluptate!
                  </li>
                  <li className="text_18_privacy">
                    <strong>Public interests:</strong> Lorem ipsum, dolor sit
                    amet consectetur adipisicing elit. Esse natus ea modi
                    similique consequatur cumque est blanditiis perferendis
                    voluptatem labore deserunt ipsa consequuntur itaque
                    recusandae dolore, rem quasi autem voluptate!
                  </li>
                  <li className="text_18_privacy">
                    <strong>Legitimate interests:</strong> Lorem ipsum, dolor
                    sit amet consectetur adipisicing elit. Esse natus ea modi
                    similique consequatur cumque est blanditiis perferendis
                    voluptatem labore deserunt ipsa consequuntur itaque
                    recusandae dolore, rem quasi autem voluptate!
                  </li>
                </ul>
                <p className="text_18_privacy">
                  Lorem ipsum, dolor sit amet consectetur adipisicing elit. Esse
                  natus ea modi similique consequatur cumque est blanditiis
                  perferendis voluptatem labore deserunt ipsa consequuntur
                  itaque recusandae dolore, rem quasi autem voluptate!
                </p>
                <h4 />
                <h4>Your Rights under the GDPR</h4>
                <p className="text_18_privacy">
                  Lorem ipsum, dolor sit amet consectetur adipisicing elit. Esse
                  natus ea modi similique consequatur cumque est blanditiis
                  perferendis voluptatem labore deserunt ipsa consequuntur
                  itaque recusandae dolore, rem quasi autem voluptate!
                </p>
                <p className="text_18_privacy">
                  Lorem ipsum, dolor sit amet consectetur adipisicing elit. Esse
                  natus ea modi similique consequatur cumque est blanditiis
                  perferendis voluptatem labore deserunt ipsa consequuntur
                  itaque recusandae dolore, rem quasi autem voluptate!
                </p>
                <ul>
                  <li className="text_18_privacy">
                    <strong>Request access to Your Personal Data.</strong> Lorem
                    ipsum, dolor sit amet consectetur adipisicing elit. Esse
                    natus ea modi similique consequatur cumque est blanditiis
                    perferendis voluptatem labore deserunt ipsa consequuntur
                    itaque recusandae dolore, rem quasi autem voluptate!
                  </li>
                  <li className="text_18_privacy">
                    <strong>
                      Request correction of the Personal Data that We hold about
                      You.
                    </strong>{" "}
                    Lorem ipsum, dolor sit amet consectetur adipisicing elit.
                    Esse natus ea modi similique consequatur cumque est
                    blanditiis perferendis voluptatem labore deserunt ipsa
                    consequuntur itaque recusandae dolore, rem quasi autem
                    voluptate!
                  </li>
                  <li className="text_18_privacy">
                    <strong>Object to processing of Your Personal Data.</strong>{" "}
                    Lorem ipsum, dolor sit amet consectetur adipisicing elit.
                    Esse natus ea modi similique consequatur cumque est
                    blanditiis perferendis voluptatem labore deserunt ipsa
                    consequuntur itaque recusandae dolore, rem quasi autem
                    voluptate!
                  </li>
                  <li className="text_18_privacy">
                    <strong>Request erasure of Your Personal Data.</strong>{" "}
                    Lorem ipsum, dolor sit amet consectetur adipisicing elit.
                    Esse natus ea modi similique consequatur cumque est
                    blanditiis perferendis voluptatem labore deserunt ipsa
                    consequuntur itaque recusandae dolore, rem quasi autem
                    voluptate!
                  </li>
                  <li className="text_18_privacy">
                    <strong>Request the transfer of Your Personal Data.</strong>{" "}
                    Lorem ipsum, dolor sit amet consectetur adipisicing elit.
                    Esse natus ea modi similique consequatur cumque est
                    blanditiis perferendis voluptatem labore deserunt ipsa
                    consequuntur itaque recusandae dolore, rem quasi autem
                    voluptate!
                  </li>
                  <li className="text_18_privacy">
                    <strong>Withdraw Your consent.</strong> Lorem ipsum, dolor
                    sit amet consectetur adipisicing elit. Esse natus ea modi
                    similique consequatur cumque est blanditiis perferendis
                    voluptatem labore deserunt ipsa consequuntur itaque
                    recusandae dolore, rem quasi autem voluptate!
                  </li>
                </ul>
                <h4 />
                <h4>Exercising of Your GDPR Data Protection Rights</h4>
                <p className="text_18_privacy">
                  Lorem ipsum, dolor sit amet consectetur adipisicing elit. Esse
                  natus ea modi similique consequatur cumque est blanditiis
                  perferendis voluptatem labore deserunt ipsa consequuntur
                  itaque recusandae dolore, rem quasi autem voluptate!
                </p>
                <p className="text_18_privacy">
                  Lorem ipsum, dolor sit amet consectetur adipisicing elit. Esse
                  natus ea modi similique consequatur cumque est blanditiis
                  perferendis voluptatem labore deserunt ipsa consequuntur
                  itaque recusandae dolore, rem quasi autem voluptate!
                </p>
                <h3 />
                <h3>CCPA/CPRA Privacy Notice</h3>
                <p className="text_18_privacy">
                  Lorem ipsum, dolor sit amet consectetur adipisicing elit. Esse
                  natus ea modi similique consequatur cumque est blanditiis
                  perferendis voluptatem labore deserunt ipsa consequuntur
                  itaque recusandae dolore, rem quasi autem voluptate!
                </p>
                <h4 />
                <h4>Categories of Personal Information Collected</h4>
                <p className="text_18_privacy">
                  Lorem ipsum, dolor sit amet consectetur adipisicing elit. Esse
                  natus ea modi similique consequatur cumque est blanditiis
                  perferendis voluptatem labore deserunt ipsa consequuntur
                  itaque recusandae dolore, rem quasi autem voluptate!
                </p>
                <p className="text_18_privacy">
                  Lorem ipsum, dolor sit amet consectetur adipisicing elit. Esse
                  natus ea modi similique consequatur cumque est blanditiis
                  perferendis voluptatem labore deserunt ipsa consequuntur
                  itaque recusandae dolore, rem quasi autem voluptate!
                </p>
                <h5 />
                <p className="text_18_privacy">
                  <strong>Category A: Identifiers.</strong>
                </p>
                <p className="text_18_privacy">
                  Lorem ipsum, dolor sit amet consectetur adipisicing elit. Esse
                  natus ea modi similique consequatur cumque est blanditiis
                  perferendis voluptatem labore deserunt ipsa consequuntur
                  itaque recusandae dolore, rem quasi autem voluptate!
                </p>
                <p className="text_18_privacy">Collected: Yes.</p>
                <h5 />
                <p className="text_18_privacy">
                  <strong>
                    Category B: Personal information categories listed in the
                    California Customer Records statute (Cal. Civ. Code §
                    1798.80(e)).
                  </strong>
                </p>
                <p className="text_18_privacy">
                  Examples: Lorem ipsum, dolor sit amet consectetur adipisicing
                  elit. Esse natus ea modi similique consequatur cumque est
                  blanditiis perferendis voluptatem labore deserunt ipsa
                  consequuntur itaque recusandae dolore, rem quasi autem
                  voluptate!
                </p>
                <p className="text_18_privacy">Collected: Yes.</p>
                <h5 />
                <p className="text_18_privacy">
                  <strong>
                    Category C: Lorem ipsum, dolor sit amet consectetur
                    adipisicing elit. Esse natus ea modi similique consequatur
                    cumque est blanditiis perferendis voluptatem labore deserunt
                    ipsa consequuntur itaque recusandae dolore, rem quasi autem
                    voluptate!
                  </strong>
                </p>
                <p className="text_18_privacy">
                  Examples: Lorem ipsum, dolor sit amet consectetur adipisicing
                  elit. Esse natus ea modi similique consequatur cumque est
                  blanditiis perferendis voluptatem labore deserunt ipsa
                  consequuntur itaque recusandae dolore, rem quasi autem
                  voluptate!
                </p>
                <p className="text_18_privacy">Collected: No.</p>
                <h5 />
                <p className="text_18_privacy">
                  <strong>Category D: Commercial information.</strong>
                </p>
                <p className="text_18_privacy">
                  Examples: Records and history of products or services
                  purchased or considered.
                </p>
                <p className="text_18_privacy">Collected: No.</p>
                <h5 />
                <p className="text_18_privacy">
                  <strong>Category E: Biometric information.</strong>
                </p>
                <p className="text_18_privacy">
                  Lorem ipsum, dolor sit amet consectetur adipisicing elit. Esse
                  natus ea modi similique consequatur cumque est blanditiis
                  perferendis voluptatem labore deserunt ipsa consequuntur
                  itaque recusandae dolore, rem quasi autem voluptate!
                </p>
                <p className="text_18_privacy">Collected: No.</p>
                <h5 />
                <p className="text_18_privacy">
                  <strong>
                    Category F: Internet or other similar network activity.
                  </strong>
                </p>
                <p className="text_18_privacy">
                  Examples: Interaction with our Service or advertisement.
                </p>
                <p className="text_18_privacy">Collected: Yes.</p>
                <h5 />
                <p className="text_18_privacy">
                  <strong>Category G: Geolocation data.</strong>
                </p>
                <p className="text_18_privacy">Examples: Approximate physical location.</p>
                <p className="text_18_privacy">Collected: No.</p>
                <h5 />
                <p className="text_18_privacy">
                  <strong>Category H: Sensory data.</strong>
                </p>
                <p className="text_18_privacy">
                  Examples: Audio, electronic, visual, thermal, olfactory, or
                  similar information.
                </p>
                <p className="text_18_privacy">Collected: No.</p>
                <p />
                <p className="text_18_privacy">
                  <strong>
                    Category I: Professional or employment-related information.
                  </strong>
                </p>
                <p className="text_18_privacy">
                  Examples: Current or past job history or performance
                  evaluations.
                </p>
                <p className="text_18_privacy">Collected: No.</p>
                <h5 />
                <p className="text_18_privacy">
                  <strong>
                    Lorem ipsum, dolor sit amet consectetur adipisicing elit.
                    Esse natus ea modi similique consequatur cumque est
                    blanditiis perferendis voluptatem labore deserunt ipsa
                    consequuntur itaque recusandae dolore, rem quasi autem
                    voluptate!
                  </strong>
                </p>
                <p className="text_18_privacy">
                  Examples: Lorem ipsum, dolor sit amet consectetur adipisicing
                  elit. Esse natus ea modi similique consequatur cumque est
                  blanditiis perferendis voluptatem labore deserunt ipsa
                  consequuntur itaque recusandae dolore, rem quasi autem
                  voluptate!
                </p>
                <p className="text_18_privacy">Collected: No.</p>
                <h5 />
                <p className="text_18_privacy">
                  <strong>
                    Category K: Lorem ipsum, dolor sit amet consectetur
                    adipisicing elit. Esse natus ea modi similique consequatur
                    cumque est blanditiis perferendis voluptatem labore deserunt
                    ipsa consequuntur itaque recusandae dolore, rem quasi autem
                    voluptate!
                  </strong>
                </p>
                <p className="text_18_privacy">
                  Examples: Lorem ipsum, dolor sit amet consectetur adipisicing
                  elit. Esse natus ea modi similique consequatur cumque est
                  blanditiis perferendis voluptatem labore deserunt ipsa
                  consequuntur itaque recusandae dolore, rem quasi autem
                  voluptate!
                </p>
                <p className="text_18_privacy">Collected: No.</p>
                <h5 />
                <p className="text_18_privacy">
                  <strong>Category L: Sensitive personal information.</strong>
                </p>
                <p className="text_18_privacy">
                  Examples: Account login and password information, geolocation
                  data.
                </p>
                <p className="text_18_privacy">Collected: Yes.</p>
                <p className="text_18_privacy">
                  Under CCPA/CPRA, personal information does not include:
                </p>
                <ul>
                  <li className="text_18_privacy">
                    Publicly available information from government records
                  </li>
                  <li className="text_18_privacy">
                    Deidentified or aggregated consumer information
                  </li>
                  <li className="text_18_privacy">
                    Information excluded from the CCPA/CPRA's scope, such as:
                    <ul>
                      <li className="text_18_privacy">
                        Lorem ipsum, dolor sit amet consectetur adipisicing
                        elit. Esse natus ea modi similique consequatur cumque
                        est blanditiis perferendis voluptatem labore deserunt
                        ipsa consequuntur itaque recusandae dolore, rem quasi
                        autem voluptate!
                      </li>
                      <li className="text_18_privacy">
                        Lorem ipsum, dolor sit amet consectetur adipisicing
                        elit. Esse natus ea modi similique consequatur cumque
                        est blanditiis perferendis voluptatem labore deserunt
                        ipsa consequuntur itaque recusandae dolore, rem quasi
                        autem voluptate!
                      </li>
                    </ul>
                  </li>
                </ul>
                <h3 />
                <h3>Sources of Personal Information</h3>
                <p className="text_18_privacy">
                  Lorem ipsum, dolor sit amet consectetur adipisicing elit. Esse
                  natus ea modi similique consequatur cumque est blanditiis
                  perferendis voluptatem labore deserunt ipsa consequuntur
                  itaque recusandae dolore, rem quasi autem voluptate!
                </p>
                <ul>
                  <li className="text_18_privacy">
                    <strong>Directly from You</strong>. Lorem ipsum, dolor sit
                    amet consectetur adipisicing elit. Esse natus ea modi
                    similique consequatur cumque est blanditiis perferendis
                    voluptatem labore deserunt ipsa consequuntur itaque
                    recusandae dolore, rem quasi autem voluptate!
                  </li>
                  <li className="text_18_privacy">
                    <strong>Indirectly from You</strong>. Lorem ipsum, dolor sit
                    amet consectetur adipisicing elit. Esse natus ea modi
                    similique consequatur cumque est blanditiis perferendis
                    voluptatem labore deserunt ipsa consequuntur itaque
                    recusandae dolore, rem quasi autem voluptate!
                  </li>
                  <li className="text_18_privacy">
                    <strong>Automatically from You</strong>. Lorem ipsum, dolor
                    sit amet consectetur adipisicing elit. Esse natus ea modi
                    similique consequatur cumque est blanditiis perferendis
                    voluptatem labore deserunt ipsa consequuntur itaque
                    recusandae dolore, rem quasi autem voluptate!
                  </li>
                  <li className="text_18_privacy">
                    <strong>From Service Providers</strong>. Lorem ipsum, dolor
                    sit amet consectetur adipisicing elit. Esse natus ea modi
                    similique consequatur cumque est blanditiis perferendis
                    voluptatem labore deserunt ipsa consequuntur itaque
                    recusandae dolore, rem quasi autem voluptate!
                  </li>
                </ul>
                <h3 />
                <h3>Use of Personal Information</h3>
                <p className="text_18_privacy">
                  Lorem ipsum, dolor sit amet consectetur adipisicing elit. Esse
                  natus ea modi similique consequatur cumque est blanditiis
                  perferendis voluptatem labore deserunt ipsa consequuntur
                  itaque recusandae dolore, rem quasi autem voluptate!
                </p>
                <ul>
                  <li className="text_18_privacy">
                    {" "}
                    Lorem ipsum, dolor sit amet consectetur adipisicing elit.
                    Esse natus ea modi similique consequatur cumque est
                    blanditiis perferendis voluptatem labore deserunt ipsa
                    consequuntur itaque recusandae dolore, rem quasi autem
                    voluptate!
                  </li>
                  <li className="text_18_privacy">
                    Lorem ipsum, dolor sit amet consectetur adipisicing elit.
                    Esse natus ea modi similique consequatur cumque est
                    blanditiis perferendis voluptatem labore deserunt ipsa
                    consequuntur itaque recusandae dolore, rem quasi autem
                    voluptate!
                  </li>
                  <li className="text_18_privacy">
                    Lorem ipsum, dolor sit amet consectetur adipisicing elit.
                    Esse natus ea modi similique consequatur cumque est
                    blanditiis perferendis voluptatem labore deserunt ipsa
                    consequuntur itaque recusandae dolore, rem quasi autem
                    voluptate!
                  </li>
                  <li className="text_18_privacy">
                    Lorem ipsum, dolor sit amet consectetur adipisicing elit.
                    Esse natus ea modi similique consequatur cumque est
                    blanditiis perferendis voluptatem labore deserunt ipsa
                    consequuntur itaque recusandae dolore, rem quasi autem
                    voluptate!
                  </li>
                  <li className="text_18_privacy">
                    Lorem ipsum, dolor sit amet consectetur adipisicing elit.
                    Esse natus ea modi similique consequatur cumque est
                    blanditiis perferendis voluptatem labore deserunt ipsa
                    consequuntur itaque recusandae dolore, rem quasi autem
                    voluptate!
                  </li>
                  <li className="text_18_privacy">
                    {" "}
                    Lorem ipsum, dolor sit amet consectetur adipisicing elit.
                    Esse natus ea modi similique consequatur cumque est
                    blanditiis perferendis voluptatem labore deserunt ipsa
                    consequuntur itaque recusandae dolore, rem quasi autem
                    voluptate!
                  </li>
                  <li className="text_18_privacy">
                    Lorem ipsum, dolor sit amet consectetur adipisicing elit.
                    Esse natus ea modi similique consequatur cumque est
                    blanditiis perferendis voluptatem labore deserunt ipsa
                    consequuntur itaque recusandae dolore, rem quasi autem
                    voluptate!
                  </li>
                  <li className="text_18_privacy">Other one-time uses.</li>
                </ul>
                <p className="text_18_privacy">
                  Lorem ipsum, dolor sit amet consectetur adipisicing elit. Esse
                  natus ea modi similique consequatur cumque est blanditiis
                  perferendis voluptatem labore deserunt ipsa consequuntur
                  itaque recusandae dolore, rem quasi autem voluptate!
                </p>
                <p className="text_18_privacy">
                  Lorem ipsum, dolor sit amet consectetur adipisicing elit. Esse
                  natus ea modi similique consequatur cumque est blanditiis
                  perferendis voluptatem labore deserunt ipsa consequuntur
                  itaque recusandae dolore, rem quasi autem voluptate!
                </p>
                <h3 />
                <h3>Disclosure of Personal Information</h3>
                <p className="text_18_privacy">
                  Lorem ipsum, dolor sit amet consectetur adipisicing elit. Esse
                  natus ea modi similique consequatur cumque est blanditiis
                  perferendis voluptatem labore deserunt ipsa consequuntur
                  itaque recusandae dolore, rem quasi autem voluptate!
                </p>
                <ul>
                  <li className="text_18_privacy">Category A: Identifiers</li>
                  <li className="text_18_privacy">
                    Lorem ipsum, dolor sit amet consectetur adipisicing elit.
                    Esse natus ea modi similique consequatur cumque est
                    blanditiis perferendis voluptatem labore deserunt ipsa
                    consequuntur itaque recusandae dolore, rem quasi autem
                    voluptate!
                  </li>
                  <li className="text_18_privacy">
                    {" "}
                    Lorem ipsum, dolor sit amet consectetur adipisicing elit.
                    Esse natus ea modi similique consequatur cumque est
                    blanditiis perferendis voluptatem labore deserunt ipsa
                    consequuntur itaque recusandae dolore, rem quasi autem
                    voluptate!
                  </li>
                </ul>
                <p className="text_18_privacy">
                  Lorem ipsum, dolor sit amet consectetur adipisicing elit. Esse
                  natus ea modi similique consequatur cumque est blanditiis
                  perferendis voluptatem labore deserunt ipsa consequuntur
                  itaque recusandae dolore, rem quasi autem voluptate!
                </p>
                <p className="text_18_privacy">
                  Lorem ipsum, dolor sit amet consectetur adipisicing elit. Esse
                  natus ea modi similique consequatur cumque est blanditiis
                  perferendis voluptatem labore deserunt ipsa consequuntur
                  itaque recusandae dolore, rem quasi autem voluptate!
                </p>
                <h3 />
                <h3>Share of Personal Information</h3>
                <p className="text_18_privacy">
                  Lorem ipsum, dolor sit amet consectetur adipisicing elit. Esse
                  natus ea modi similique consequatur cumque est blanditiis
                  perferendis voluptatem labore deserunt ipsa consequuntur
                  itaque recusandae dolore, rem quasi autem voluptate!
                </p>
                <ul>
                  <li className="text_18_privacy">Service Providers</li>
                  <li className="text_18_privacy">Our affiliates</li>
                  <li className="text_18_privacy">Our business partners</li>
                  <li className="text_18_privacy">
                    Lorem ipsum, dolor sit amet consectetur adipisicing elit.
                    Esse natus ea modi similique consequatur cumque est
                    blanditiis perferendis voluptatem labore deserunt ipsa
                    consequuntur itaque recusandae dolore, rem quasi autem
                    voluptate!
                  </li>
                </ul>
                <h3 />
                <h3>Sale of Personal Information</h3>
                <p className="text_18_privacy">
                  Lorem ipsum, dolor sit amet consectetur adipisicing elit. Esse
                  natus ea modi similique consequatur cumque est blanditiis
                  perferendis voluptatem labore deserunt ipsa consequuntur
                  itaque recusandae dolore, rem quasi autem voluptate!
                </p>
                <p className="text_18_privacy">
                  Lorem ipsum, dolor sit amet consectetur adipisicing elit. Esse
                  natus ea modi similique consequatur cumque est blanditiis
                  perferendis voluptatem labore deserunt ipsa consequuntur
                  itaque recusandae dolore, rem quasi autem voluptate!
                </p>
                <p className="text_18_privacy">
                  We may sell and may have sold in the last twelve (12) months
                  the following categories of personal information:
                </p>
                <ul>
                  <li className="text_18_privacy">Category A: Identifiers</li>
                  <li className="text_18_privacy">
                    Lorem ipsum, dolor sit amet consectetur adipisicing elit.
                    Esse natus ea modi similique consequatur cumque est
                    blanditiis perferendis voluptatem labore deserunt ipsa
                    consequuntur itaque recusandae dolore, rem quasi autem
                    voluptate!
                  </li>
                  <li className="text_18_privacy">
                    Category F: Internet or other similar network activity
                  </li>
                </ul>
                <p className="text_18_privacy">
                  Lorem ipsum, dolor sit amet consectetur adipisicing elit. Esse
                  natus ea modi similique consequatur cumque est blanditiis
                  perferendis voluptatem labore deserunt ipsa consequuntur
                  itaque recusandae dolore, rem quasi autem voluptate!
                </p>
                <h3 />
                <h3>
                  Sale of Personal Information of Minors Under 16 Years of Age
                </h3>
                <p className="text_18_privacy">
                  Lorem ipsum, dolor sit amet consectetur adipisicing elit. Esse
                  natus ea modi similique consequatur cumque est blanditiis
                  perferendis voluptatem labore deserunt ipsa consequuntur
                  itaque recusandae dolore, rem quasi autem voluptate!
                </p>
                <p className="text_18_privacy">
                  Lorem ipsum, dolor sit amet consectetur adipisicing elit. Esse
                  natus ea modi similique consequatur cumque est blanditiis
                  perferendis voluptatem labore deserunt ipsa consequuntur
                  itaque recusandae dolore, rem quasi autem voluptate!
                </p>
                <p className="text_18_privacy">
                  Lorem ipsum, dolor sit amet consectetur adipisicing elit. Esse
                  natus ea modi similique consequatur cumque est blanditiis
                  perferendis voluptatem labore deserunt ipsa consequuntur
                  itaque recusandae dolore, rem quasi autem voluptate!
                </p>
                <h3 />
                <h3>Your Rights under the CCPA/CPRA</h3>
                <p className="text_18_privacy">
                  Lorem ipsum, dolor sit amet consectetur adipisicing elit. Esse
                  natus ea modi similique consequatur cumque est blanditiis
                  perferendis voluptatem labore deserunt ipsa consequuntur
                  itaque recusandae dolore, rem quasi autem voluptate!
                </p>
                <ul>
                  <li className="text_18_privacy">
                    <strong>The right to notice.</strong> Lorem ipsum, dolor sit
                    amet consectetur adipisicing elit. Esse natus ea modi
                    similique consequatur cumque est blanditiis perferendis
                    voluptatem labore deserunt ipsa consequuntur itaque
                    recusandae dolore, rem quasi autem voluptate!
                  </li>
                  <li className="text_18_privacy">
                    <strong>The right to know/access.</strong> Lorem ipsum,
                    dolor sit amet consectetur adipisicing elit. Esse natus ea
                    modi similique consequatur cumque est blanditiis perferendis
                    voluptatem labore deserunt ipsa consequuntur itaque
                    recusandae dolore, rem quasi autem voluptate!
                    <ul>
                      <li className="text_18_privacy">
                        The categories of personal information We collected
                        about You
                      </li>
                      <li className="text_18_privacy">
                        The categories of sources for the personal information
                        We collected about You
                      </li>
                      <li className="text_18_privacy">
                        Our business or commercial purposes for collecting or
                        selling that personal information
                      </li>
                      <li className="text_18_privacy">
                        The categories of third parties with whom We share that
                        personal information
                      </li>
                      <li className="text_18_privacy">
                        The specific pieces of personal information We collected
                        about You
                      </li>
                      <li className="text_18_privacy">
                        If we sold Your personal information or disclosed Your
                        personal information for a business purpose, We will
                        disclose to You:
                        <ul>
                          <li className="text_18_privacy">
                            The categories of personal information categories
                            sold
                          </li>
                          <li className="text_18_privacy">
                            The categories of personal information categories
                            disclosed
                          </li>
                        </ul>
                      </li>
                    </ul>
                  </li>
                  <li className="text_18_privacy">
                    <strong>
                      The right to say no to the sale or sharing of Personal
                      Data (opt-out).
                    </strong>{" "}
                    Lorem ipsum, dolor sit amet consectetur adipisicing elit.
                    Esse natus ea modi similique consequatur cumque est
                    blanditiis perferendis voluptatem labore deserunt ipsa
                    consequuntur itaque recusandae dolore, rem quasi autem
                    voluptate!
                  </li>
                  <li className="text_18_privacy">
                    <strong>The right to correct Personal Data.</strong> Lorem
                    ipsum, dolor sit amet consectetur adipisicing elit. Esse
                    natus ea modi similique consequatur cumque est blanditiis
                    perferendis voluptatem labore deserunt ipsa consequuntur
                    itaque recusandae dolore, rem quasi autem voluptate!
                  </li>
                  <li className="text_18_privacy">
                    <strong>
                      The right to limit use and disclosure of sensitive
                      Personal Data.
                    </strong>{" "}
                    Lorem ipsum, dolor sit amet consectetur adipisicing elit.
                    Esse natus ea modi similique consequatur cumque est
                    blanditiis perferendis voluptatem labore deserunt ipsa
                    consequuntur itaque recusandae dolore, rem quasi autem
                    voluptate!
                  </li>
                  <li className="text_18_privacy">
                    <strong>The right to delete Personal Data.</strong> Lorem
                    ipsum, dolor sit amet consectetur adipisicing elit. Esse
                    natus ea modi similique consequatur cumque est blanditiis
                    perferendis voluptatem labore deserunt ipsa consequuntur
                    itaque recusandae dolore, rem quasi autem voluptate!
                    <ul>
                      <li className="text_18_privacy">
                        Lorem ipsum, dolor sit amet consectetur adipisicing
                        elit. Esse natus ea modi similique consequatur cumque
                        est blanditiis perferendis voluptatem labore deserunt
                        ipsa consequuntur itaque recusandae dolore, rem quasi
                        autem voluptate!
                      </li>
                      <li className="text_18_privacy">
                        Lorem ipsum, dolor sit amet consectetur adipisicing
                        elit. Esse natus ea modi similique consequatur cumque
                        est blanditiis perferendis voluptatem labore deserunt
                        ipsa consequuntur itaque recusandae dolore, rem quasi
                        autem voluptate!
                      </li>
                      <li className="text_18_privacy">
                        Lorem ipsum, dolor sit amet consectetur adipisicing
                        elit. Esse natus ea modi similique consequatur cumque
                        est blanditiis perferendis voluptatem labore deserunt
                        ipsa consequuntur itaque recusandae dolore, rem quasi
                        autem voluptate!
                      </li>
                      <li className="text_18_privacy">
                        Lorem ipsum, dolor sit amet consectetur adipisicing
                        elit. Esse natus ea modi similique consequatur cumque
                        est blanditiis perferendis voluptatem labore deserunt
                        ipsa consequuntur itaque recusandae dolore, rem quasi
                        autem voluptate!
                      </li>
                      <li className="text_18_privacy">
                        Lorem ipsum, dolor sit amet consectetur adipisicing
                        elit. Esse natus ea modi similique consequatur cumque
                        est blanditiis perferendis voluptatem labore deserunt
                        ipsa consequuntur itaque recusandae dolore, rem quasi
                        autem voluptate!
                      </li>
                      <li className="text_18_privacy">
                        Lorem ipsum, dolor sit amet consectetur adipisicing
                        elit. Esse natus ea modi similique consequatur cumque
                        est blanditiis perferendis voluptatem labore deserunt
                        ipsa consequuntur itaque recusandae dolore, rem quasi
                        autem voluptate!
                      </li>
                      <li className="text_18_privacy">
                        Lorem ipsum, dolor sit amet consectetur adipisicing
                        elit. Esse natus ea modi similique consequatur cumque
                        est blanditiis perferendis voluptatem labore deserunt
                        ipsa consequuntur itaque recusandae dolore, rem quasi
                        autem voluptate!
                      </li>
                      <li className="text_18_privacy">Comply with a legal obligation.</li>
                      <li className="text_18_privacy">
                        Lorem ipsum, dolor sit amet consectetur adipisicing
                        elit. Esse natus ea modi similique consequatur cumque
                        est blanditiis perferendis voluptatem labore deserunt
                        ipsa consequuntur itaque recusandae dolore, rem quasi
                        autem voluptate!
                      </li>
                    </ul>
                  </li>
                  <li className="text_18_privacy">
                    <strong>The right not to be discriminated against.</strong>{" "}
                    Lorem ipsum, dolor sit amet consectetur adipisicing elit.
                    Esse natus ea modi similique consequatur cumque est
                    blanditiis perferendis voluptatem labore deserunt ipsa
                    consequuntur itaque recusandae dolore, rem quasi autem
                    voluptate!
                    <ul>
                      <li className="text_18_privacy">Denying goods or services to You</li>
                      <li className="text_18_privacy">
                        Lorem ipsum, dolor sit amet consectetur adipisicing
                        elit. Esse natus ea modi similique consequatur cumque
                        est blanditiis perferendis voluptatem labore deserunt
                        ipsa consequuntur itaque recusandae dolore, rem quasi
                        autem voluptate!
                      </li>
                      <li className="text_18_privacy">
                        Lorem ipsum, dolor sit amet consectetur adipisicing
                        elit. Esse natus ea modi similique consequatur cumque
                        est blanditiis perferendis voluptatem labore deserunt
                        ipsa consequuntur itaque recusandae dolore, rem quasi
                        autem voluptate!
                      </li>
                      <li className="text_18_privacy">
                        Lorem ipsum, dolor sit amet consectetur adipisicing
                        elit. Esse natus ea modi similique consequatur cumque
                        est blanditiis perferendis voluptatem labore deserunt
                        ipsa consequuntur itaque recusandae dolore, rem quasi
                        autem voluptate!
                      </li>
                    </ul>
                  </li>
                </ul>
                <h3 />
                <h3>Exercising Your CCPA/CPRA Data Protection Rights</h3>
                <p className="text_18_privacy">
                  Lorem ipsum, dolor sit amet consectetur adipisicing elit. Esse
                  natus ea modi similique consequatur cumque est blanditiis
                  perferendis voluptatem labore deserunt ipsa consequuntur
                  itaque recusandae dolore, rem quasi autem voluptate!
                </p>
                <p className="text_18_privacy">
                  Lorem ipsum, dolor sit amet consectetur adipisicing elit. Esse
                  natus ea modi similique consequatur cumque est blanditiis
                  perferendis voluptatem labore deserunt ipsa consequuntur
                  itaque recusandae dolore, rem quasi autem voluptate!
                </p>
                <ul>
                  <li className="text_18_privacy">
                    By email: <strong>contact@immsy.com</strong>
                  </li>
                </ul>
                <p className="text_18_privacy">
                  Lorem ipsum, dolor sit amet consectetur adipisicing elit. Esse
                  natus ea modi similique consequatur cumque est blanditiis
                  perferendis voluptatem labore deserunt ipsa consequuntur
                  itaque recusandae dolore, rem quasi autem voluptate!
                </p>
                <p className="text_18_privacy">Your request to Us must:</p>
                <ul>
                  <li className="text_18_privacy">
                    Lorem ipsum, dolor sit amet consectetur adipisicing elit.
                    Esse natus ea modi similique consequatur cumque est
                    blanditiis perferendis voluptatem labore deserunt ipsa
                    consequuntur itaque recusandae dolore, rem quasi autem
                    voluptate!
                  </li>
                  <li className="text_18_privacy">
                    Lorem ipsum, dolor sit amet consectetur adipisicing elit.
                    Esse natus ea modi similique consequatur cumque est
                    blanditiis perferendis voluptatem labore deserunt ipsa
                    consequuntur itaque recusandae dolore, rem quasi autem
                    voluptate!
                  </li>
                </ul>
                <p className="text_18_privacy">
                  Lorem ipsum, dolor sit amet consectetur adipisicing elit. Esse
                  natus ea modi similique consequatur cumque est blanditiis
                  perferendis voluptatem labore deserunt ipsa consequuntur
                  itaque recusandae dolore, rem quasi autem voluptate!
                </p>
                <ul>
                  <li className="text_18_privacy">
                    Verify Your identity or authority to make the request
                  </li>
                  <li className="text_18_privacy">
                    And confirm that the personal information relates to You
                  </li>
                </ul>
                <p className="text_18_privacy">
                  Lorem ipsum, dolor sit amet consectetur adipisicing elit. Esse
                  natus ea modi similique consequatur cumque est blanditiis
                  perferendis voluptatem labore deserunt ipsa consequuntur
                  itaque recusandae dolore, rem quasi autem voluptate!
                </p>
                <p className="text_18_privacy">
                  Lorem ipsum, dolor sit amet consectetur adipisicing elit. Esse
                  natus ea modi similique consequatur cumque est blanditiis
                  perferendis voluptatem labore deserunt ipsa consequuntur
                  itaque recusandae dolore, rem quasi autem voluptate!
                </p>
                <p className="text_18_privacy">
                  Lorem ipsum, dolor sit amet consectetur adipisicing elit. Esse
                  natus ea modi similique consequatur cumque est blanditiis
                  perferendis voluptatem labore deserunt ipsa consequuntur
                  itaque recusandae dolore, rem quasi autem voluptate!
                </p>
                <h3 />
                <h3>Do Not Sell My Personal Information</h3>
                <p className="text_18_privacy">
                  Lorem ipsum, dolor sit amet consectetur adipisicing elit. Esse
                  natus ea modi similique consequatur cumque est blanditiis
                  perferendis voluptatem labore deserunt ipsa consequuntur
                  itaque recusandae dolore, rem quasi autem voluptate!
                </p>
                <p className="text_18_privacy">
                  Lorem ipsum, dolor sit amet consectetur adipisicing elit. Esse
                  natus ea modi similique consequatur cumque est blanditiis
                  perferendis voluptatem labore deserunt ipsa consequuntur
                  itaque recusandae dolore, rem quasi autem voluptate!
                </p>
                <p className="text_18_privacy">
                  Lorem ipsum, dolor sit amet consectetur adipisicing elit. Esse
                  natus ea modi similique consequatur cumque est blanditiis
                  perferendis voluptatem labore deserunt ipsa consequuntur
                  itaque recusandae dolore, rem quasi autem voluptate!
                </p>
                <p className="text_18_privacy">
                  Lorem ipsum, dolor sit amet consectetur adipisicing elit. Esse
                  natus ea modi similique consequatur cumque est blanditiis
                  perferendis voluptatem labore deserunt ipsa consequuntur
                  itaque recusandae dolore, rem quasi autem voluptate!
                </p>
                <p className="text_18_privacy">
                  Lorem ipsum, dolor sit amet consectetur adipisicing elit. Esse
                  natus ea modi similique consequatur cumque est blanditiis
                  perferendis voluptatem labore deserunt ipsa consequuntur
                  itaque recusandae dolore, rem quasi autem voluptate!
                </p>
                <h4 />
                <h4>Website</h4>
                <p className="text_18_privacy">
                  Lorem ipsum, dolor sit amet consectetur adipisicing elit. Esse
                  natus ea modi similique consequatur cumque est blanditiis
                  perferendis voluptatem labore deserunt ipsa consequuntur
                  itaque recusandae dolore, rem quasi autem voluptate!
                </p>
                <p className="text_18_privacy">
                  Lorem ipsum, dolor sit amet consectetur adipisicing elit. Esse
                  natus ea modi similique consequatur cumque est blanditiis
                  perferendis voluptatem labore deserunt ipsa consequuntur
                  itaque recusandae dolore, rem quasi autem voluptate!
                </p>
                <ul>
                  <li className="text_18_privacy">
                    Lorem ipsum, dolor sit amet consectetur adipisicing elit.
                    Esse natus ea modi similique consequatur cumque est
                    blanditiis perferendis voluptatem labore deserunt ipsa
                    consequuntur itaque recusandae dolore, rem quasi autem
                    voluptate!
                  </li>
                  <li className="text_18_privacy">
                    Lorem ipsum, dolor sit amet consectetur adipisicing elit.
                    Esse natus ea modi similique consequatur cumque est
                    blanditiis perferendis voluptatem labore deserunt ipsa
                    consequuntur itaque recusandae dolore, rem quasi autem
                    voluptate!
                  </li>
                  <li className="text_18_privacy">
                    Lorem ipsum, dolor sit amet consectetur adipisicing elit.
                    Esse natus ea modi similique consequatur cumque est
                    blanditiis perferendis voluptatem labore deserunt ipsa
                    consequuntur itaque recusandae dolore, rem quasi autem
                    voluptate!
                  </li>
                </ul>
                <p className="text_18_privacy">
                  Lorem ipsum, dolor sit amet consectetur adipisicing elit. Esse
                  natus ea modi similique consequatur cumque est blanditiis
                  perferendis voluptatem labore deserunt ipsa consequuntur
                  itaque recusandae dolore, rem quasi autem voluptate!
                </p>
                <h4 />
                <h4>Mobile Devices</h4>
                <p className="text_18_privacy">
                  Lorem ipsum, dolor sit amet consectetur adipisicing elit. Esse
                  natus ea modi similique consequatur cumque est blanditiis
                  perferendis voluptatem labore deserunt ipsa consequuntur
                  itaque recusandae dolore, rem quasi autem voluptate!
                </p>
                <ul>
                  <li className="text_18_privacy">
                    Lorem ipsum, dolor sit amet consectetur adipisicing elit.
                    Esse natus ea modi similique consequatur cumque est
                    blanditiis perferendis voluptatem labore deserunt ipsa
                    consequuntur itaque recusandae dolore, rem quasi autem
                    voluptate!
                  </li>
                  <li className="text_18_privacy">"Limit Ad Tracking" on iOS devices</li>
                </ul>
                <p className="text_18_privacy">
                  Lorem ipsum, dolor sit amet consectetur adipisicing elit. Esse
                  natus ea modi similique consequatur cumque est blanditiis
                  perferendis voluptatem labore deserunt ipsa consequuntur
                  itaque recusandae dolore, rem quasi autem voluptate!
                </p>
                <h3 />
                <h3>
                  Limit the Use or Disclosure of My Sensitive Personal
                  Information
                </h3>
                <p className="text_18_privacy">
                  Lorem ipsum, dolor sit amet consectetur adipisicing elit. Esse
                  natus ea modi similique consequatur cumque est blanditiis
                  perferendis voluptatem labore deserunt ipsa consequuntur
                  itaque recusandae dolore, rem quasi autem voluptate!
                </p>
                <p className="text_18_privacy">
                  Lorem ipsum, dolor sit amet consectetur adipisicing elit. Esse
                  natus ea modi similique consequatur cumque est blanditiis
                  perferendis voluptatem labore deserunt ipsa consequuntur
                  itaque recusandae dolore, rem quasi autem voluptate!
                </p>
                <h3 />
                <h3>
                  Lorem ipsum, dolor sit amet consectetur adipisicing elit. Esse
                  natus ea modi similique consequatur cumque est blanditiis
                  perferendis voluptatem labore deserunt ipsa consequuntur
                  itaque recusandae dolore, rem quasi autem voluptate!
                </h3>
                <p className="text_18_privacy">
                  Our Service does not respond to Do Not Track signals.
                </p>
                <p className="text_18_privacy">
                  Lorem ipsum, dolor sit amet consectetur adipisicing elit. Esse
                  natus ea modi similique consequatur cumque est blanditiis
                  perferendis voluptatem labore deserunt ipsa consequuntur
                  itaque recusandae dolore, rem quasi autem voluptate!
                </p>
                <h3 />
                <h3>
                  Your California Privacy Rights (California's Shine the Light
                  law)
                </h3>
                <p className="text_18_privacy">
                  Lorem ipsum, dolor sit amet consectetur adipisicing elit. Esse
                  natus ea modi similique consequatur cumque est blanditiis
                  perferendis voluptatem labore deserunt ipsa consequuntur
                  itaque recusandae dolore, rem quasi autem voluptate!
                </p>
                <p className="text_18_privacy">
                  Lorem ipsum, dolor sit amet consectetur adipisicing elit. Esse
                  natus ea modi similique consequatur cumque est blanditiis
                  perferendis voluptatem labore deserunt ipsa consequuntur
                  itaque recusandae dolore, rem quasi autem voluptate!
                </p>
                <h3 />
                <h3>
                  Lorem ipsum, dolor sit amet consectetur adipisicing elit. Esse
                  natus ea modi similique consequatur cumque est blanditiis
                  perferendis voluptatem labore deserunt ipsa consequuntur
                  itaque recusandae dolore, rem quasi autem voluptate!
                </h3>
                <p className="text_18_privacy">
                  Lorem ipsum, dolor sit amet consectetur adipisicing elit. Esse
                  natus ea modi similique consequatur cumque est blanditiis
                  perferendis voluptatem labore deserunt ipsa consequuntur
                  itaque recusandae dolore, rem quasi autem voluptate!
                </p>
                <p className="text_18_privacy">
                  Lorem ipsum, dolor sit amet consectetur adipisicing elit. Esse
                  natus ea modi similique consequatur cumque est blanditiis
                  perferendis voluptatem labore deserunt ipsa consequuntur
                  itaque recusandae dolore, rem quasi autem voluptate!
                </p>
                <p className="text_18_privacy">
                  Lorem ipsum, dolor sit amet consectetur adipisicing elit. Esse
                  natus ea modi similique consequatur cumque est blanditiis
                  perferendis voluptatem labore deserunt ipsa consequuntur
                  itaque recusandae dolore, rem quasi autem voluptate!
                </p>
                <h3 />
                <h3>Children's Privacy</h3>
                <p className="text_18_privacy">
                  Lorem ipsum, dolor sit amet consectetur adipisicing elit. Esse
                  natus ea modi similique consequatur cumque est blanditiis
                  perferendis voluptatem labore deserunt ipsa consequuntur
                  itaque recusandae dolore, rem quasi autem voluptate!
                </p>
                <p className="text_18_privacy">
                  Lorem ipsum, dolor sit amet consectetur adipisicing elit. Esse
                  natus ea modi similique consequatur cumque est blanditiis
                  perferendis voluptatem labore deserunt ipsa consequuntur
                  itaque recusandae dolore, rem quasi autem voluptate!
                </p>
                <h3 />
                <h3>Links to Other Websites</h3>
                <p className="text_18_privacy">
                  Lorem ipsum, dolor sit amet consectetur adipisicing elit. Esse
                  natus ea modi similique consequatur cumque est blanditiis
                  perferendis voluptatem labore deserunt ipsa consequuntur
                  itaque recusandae dolore, rem quasi autem voluptate!
                </p>
                <p className="text_18_privacy">
                  Lorem ipsum, dolor sit amet consectetur adipisicing elit. Esse
                  natus ea modi similique consequatur cumque est blanditiis
                  perferendis voluptatem labore deserunt ipsa consequuntur
                  itaque recusandae dolore, rem quasi autem voluptate!
                </p>
                <h3 />
                <h3>Changes to this Privacy Policy</h3>
                <p className="text_18_privacy">
                  Lorem ipsum, dolor sit amet consectetur adipisicing elit. Esse
                  natus ea modi similique consequatur cumque est blanditiis
                  perferendis voluptatem labore deserunt ipsa consequuntur
                  itaque recusandae dolore, rem quasi autem voluptate!
                </p>
                <p className="text_18_privacy">
                  Lorem ipsum, dolor sit amet consectetur adipisicing elit. Esse
                  natus ea modi similique consequatur cumque est blanditiis
                  perferendis voluptatem labore deserunt ipsa consequuntur
                  itaque recusandae dolore, rem quasi autem voluptate!
                </p>
                <p className="text_18_privacy">
                  Lorem ipsum, dolor sit amet consectetur adipisicing elit. Esse
                  natus ea modi similique consequatur cumque est blanditiis
                  perferendis voluptatem labore deserunt ipsa consequuntur
                  itaque recusandae dolore, rem quasi autem voluptate!
                </p>
                <h3 />
                <h3>Contact Us</h3>
                <p className="text_18_privacy">
                  If you have any questions about this Privacy Policy, You can
                  contact us:
                </p>
                <p className="text_18_privacy">
                  By email: <strong>contact@immsy.com</strong>
                </p>
              </div>
            </div>
          </div>
        </section>
      </article>
    </>
  );
};

export default PrivacyPolicy;
